// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import type { FC, PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './i18next-config';

/**
 * A provider for i18next instance.
 *
 * This component is used to provide i18next instance to the app. It is used in the
 * root of the app to provide the i18next instance to all the components.
 *
 * @example
 *
 * ```tsx
 * import { TranslationProvider } from '@shared/ui-kit/providers/translation-provider';
 * <TranslationProvider>
 *   <App />
 * </TranslationProvider>;
 * ```
 *
 * @param props The props object.
 * @returns The component.
 */
export const TranslationProvider: FC<
  PropsWithChildren<{ instance?: typeof i18n }>
> = ({ children, instance = i18n }) => {
  return (
    <I18nextProvider i18n={instance} defaultNS="common">
      {children}
    </I18nextProvider>
  );
};
